(() => {
  'use strict';
  if (window.AlawooderHome) {
    window.AlawooderHome.init(document);
    return;
  }
  const remembered = new Map();
  const mounted = new Map();
  const mobile = () => window.matchMedia('(max-width: 600px)').matches;

  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-aw-home]')];
    if (scope.matches && scope.matches('[data-aw-home]')) roots.unshift(scope);
    roots.forEach(mount);
  }

  function mount(root) {
    if (mounted.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const sectionId = root.dataset.sectionId;
    const state = remembered.get(sectionId) || { product: 0, persona: 0 };
    remembered.set(sectionId, state);
    const productTrack = root.querySelector('[data-home-product-track]');
    const productCards = productTrack ? [...productTrack.children].filter((el) => el.matches('article')) : [];
    const productPrevious = root.querySelector('[data-home-product-prev]');
    const productNext = root.querySelector('[data-home-product-next]');
    const productCount = root.querySelector('[data-home-product-count]');
    const personaTrack = root.querySelector('[data-home-persona-track]');
    const personaCards = [...root.querySelectorAll('[data-home-persona]')];
    const personaDots = [...root.querySelectorAll('[data-home-persona-dot]')];
    const personaCaptions = [...root.querySelectorAll('[data-home-persona-caption]')];
    let productFrame = 0;
    let personaFrame = 0;
    let initialFrame = 0;

    function itemLeft(track, card) {
      return card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }

    function scrollCard(track, card) {
      if (!track || !card) return;
      track.scrollTo({ left: itemLeft(track, card), behavior: 'auto' });
    }

    function nearest(track, cards) {
      if (!cards.length) return 0;
      const max = track.scrollWidth - track.clientWidth;
      if (max > 1 && track.scrollLeft >= max - 2) return cards.length - 1;
      let chosen = 0;
      let shortest = Infinity;
      cards.forEach((card, index) => {
        const distance = Math.abs(itemLeft(track, card) - track.scrollLeft);
        if (distance < shortest) {
          shortest = distance;
          chosen = index;
        }
      });
      return chosen;
    }

    function selectProduct(index, scroll = false) {
      if (!productCards.length) {
        if (productCount) productCount.textContent = '00 / 00';
        if (productPrevious) productPrevious.disabled = true;
        if (productNext) productNext.disabled = true;
        return;
      }
      state.product = Math.max(0, Math.min(productCards.length - 1, index));
      if (productCount) productCount.textContent = `${String(state.product + 1).padStart(2, '0')} / ${String(productCards.length).padStart(2, '0')}`;
      if (productPrevious) productPrevious.disabled = state.product === 0;
      if (productNext) productNext.disabled = state.product === productCards.length - 1;
      if (scroll && mobile()) scrollCard(productTrack, productCards[state.product]);
    }

    function selectPersona(index, scroll = false) {
      const count = personaCards.length;
      if (!count) return;
      state.persona = (index + count) % count;
      personaCards.forEach((card, cardIndex) => {
        const distance = (cardIndex - state.persona + count) % count;
        const position = distance === 0 ? 'current' : distance === 1 ? 'next' : distance === count - 1 ? 'previous' : 'away';
        card.classList.remove('is-current', 'is-next', 'is-previous', 'is-away');
        card.classList.add(`is-${position}`);
        card.setAttribute('aria-pressed', String(cardIndex === state.persona));
      });
      personaDots.forEach((dot) => dot.setAttribute('aria-pressed', String(Number(dot.dataset.homePersonaDot) === state.persona)));
      personaCaptions.forEach((caption) => { caption.hidden = Number(caption.dataset.homePersonaCaption) !== state.persona; });
      if (scroll && mobile()) scrollCard(personaTrack, personaCards[state.persona]);
    }

    root.addEventListener('click', (event) => {
      const target = event.target.closest('button, a');
      if (!target || !root.contains(target)) return;
      if (target.matches('[data-home-product-prev]')) selectProduct(state.product - 1, true);
      if (target.matches('[data-home-product-next]')) selectProduct(state.product + 1, true);
      if (target.matches('[data-home-persona]')) selectPersona(Number(target.dataset.homePersona), true);
      if (target.matches('[data-home-persona-dot]')) selectPersona(Number(target.dataset.homePersonaDot), true);
      if (target.matches('[data-home-persona-prev]')) selectPersona(state.persona - 1, true);
      if (target.matches('[data-home-persona-next]')) selectPersona(state.persona + 1, true);
      if (target.matches('[data-home-swatch]')) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
        const card = target.closest('.aw-home-product-card');
        if (!card) return;
        event.preventDefault();
        card.querySelectorAll('[data-home-swatch]').forEach((swatch) => {
          if (swatch.tagName === 'BUTTON') swatch.setAttribute('aria-pressed', String(swatch === target));
          if (swatch === target) swatch.setAttribute('aria-current', 'true');
          else swatch.removeAttribute('aria-current');
        });
        const label = card.querySelector('[data-home-selected-finish]');
        if (label && target.dataset.label) label.textContent = target.dataset.label;
        const caption = card.querySelector('[data-home-photo-caption]');
        if (caption && target.dataset.caption) caption.textContent = target.dataset.caption;
        const price = card.querySelector('[data-home-card-price]');
        if (price && target.dataset.price) price.textContent = target.dataset.price;
        const image = card.querySelector('[data-home-primary-image]') || card.querySelector('.aw-home-product-image img');
        if (image && target.dataset.image) {
          if (target.dataset.imageSrcset) image.srcset = target.dataset.imageSrcset;
          else image.removeAttribute('srcset');
          if (target.dataset.imageSizes) image.sizes = target.dataset.imageSizes;
          image.src = target.dataset.image;
          if (target.dataset.imageWidth) image.width = Number(target.dataset.imageWidth);
          if (target.dataset.imageHeight) image.height = Number(target.dataset.imageHeight);
          if (target.dataset.alt) image.alt = target.dataset.alt;
        }
        if (target.dataset.url) {
          card.querySelectorAll('[data-product-target], .aw-home-product-image, .aw-home-product-title a, .aw-home-product-link').forEach((link) => { link.href = target.dataset.url; });
        }
      }
    }, { signal });

    if (productTrack) productTrack.addEventListener('scroll', () => {
      if (!mobile()) return;
      cancelAnimationFrame(productFrame);
      productFrame = requestAnimationFrame(() => selectProduct(nearest(productTrack, productCards)));
    }, { passive: true, signal });
    if (personaTrack) personaTrack.addEventListener('scroll', () => {
      if (!mobile()) return;
      cancelAnimationFrame(personaFrame);
      cancelAnimationFrame(initialFrame);
      personaFrame = requestAnimationFrame(() => selectPersona(nearest(personaTrack, personaCards)));
    }, { passive: true, signal });

    document.addEventListener('shopify:block:select', (event) => {
      const blockId = String(event.detail?.blockId || '');
      const personaIndex = personaCards.findIndex((card) => card.dataset.homeBlockId === blockId);
      if (personaIndex >= 0) selectPersona(personaIndex, true);
      const productIndex = productCards.findIndex((card) => card.dataset.homeBlockId === blockId);
      if (productIndex >= 0) selectProduct(productIndex, true);
    }, { signal });

    let lastWidth = 0;
    let wasMobile = mobile();
    const observer = new ResizeObserver(() => {
      const width = root.clientWidth;
      const isMobile = mobile();
      if (width === lastWidth && isMobile === wasMobile) return;
      lastWidth = width;
      wasMobile = isMobile;
      if (isMobile) {
        selectProduct(state.product, true);
        selectPersona(state.persona, true);
      } else {
        if (productTrack) productTrack.scrollLeft = 0;
        if (personaTrack) personaTrack.scrollLeft = 0;
      }
    });
    observer.observe(root);
    mounted.set(root, () => {
      controller.abort();
      observer.disconnect();
      cancelAnimationFrame(productFrame);
      cancelAnimationFrame(personaFrame);
      mounted.delete(root);
    });
    selectProduct(state.product);
    selectPersona(state.persona);
    initialFrame = requestAnimationFrame(() => {
      initialFrame = 0;
      if (mobile()) {
        selectProduct(state.product, true);
        selectPersona(state.persona, true);
      }
    });
  }

  function destroy(scope) {
    mounted.forEach((cleanup, root) => {
      if (scope === root || scope.contains(root)) {
        root.dispatchEvent(new Event('aw:home:unload'));
        cleanup();
      }
    });
  }
  window.AlawooderHome = { init, destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
